"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer id="footer" ref={ref} className="text-foreground-primary py-12 transition-all duration-[var(--duration-slow)] opacity-100 translate-y-0 !bg-[hsl(158,54%,18%)]">
      <div className="container mx-auto px-8 max-w-6xl">
        <Separator className="bg-foreground-primary/20 mb-8" />

        <div className="text-center space-y-8">
          <p className="text-base max-w-3xl mx-auto leading-relaxed">
            EILH brings together industry leaders, researchers, and innovators to explore cutting-edge topics in technology and science. Join us for an unforgettable conference experience.
          </p>

          <nav className="flex flex-wrap justify-center gap-6 items-center">
            <Link to="/HomePage" className="text-sm font-medium hover:-translate-y-2.5 transition-all duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-accent after:transition-all after:duration-200 hover:after:w-full">
              Home
            </Link>
            <Link to="/ContactSignUpPage" className="text-sm font-medium hover:-translate-y-2.5 transition-all duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-accent after:transition-all after:duration-200 hover:after:w-full">
              Contact Us
            </Link>
            <Link to="/SponsorsPage" className="text-sm font-medium hover:-translate-y-2.5 transition-all duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-accent after:transition-all after:duration-200 hover:after:w-full">
              Sponsors
            </Link>
            <Link to="/SchedulePage" className="text-sm font-medium hover:-translate-y-2.5 transition-all duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-accent after:transition-all after:duration-200 hover:after:w-full">
              Schedule
            </Link>
            <Link to="/AboutPage" className="text-sm font-medium hover:-translate-y-2.5 transition-all duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-accent after:transition-all after:duration-200 hover:after:w-full">
              About
            </Link>
            <Link to="/LogisticsPage" className="text-sm font-medium hover:-translate-y-2.5 transition-all duration-200 relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-accent after:transition-all after:duration-200 hover:after:w-full">
              Logistics
            </Link>
          </nav>
        </div>
      </div>
    </footer>;
}